import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';

export const deleteUserFromProject = async (id, userId) => {
  await api.delete(`${API_URL}/v1/project/${id}/user/${userId}/deleteUserFromProject`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};
